import { z } from 'zod';
import { TEAM_DUTY_SITUATION_VALUES } from './team-association.registry.js';
import { TeamAssignmentMemberSchema } from './team-assignment.schema.js';
import {
    ExecutionTaskCatalogSchema,
    MAX_OPERATIONAL_MEMBERS,
    MAX_OPERATIONAL_TASKS,
    OperationalCustomFieldsSchema,
    refineExecutionDefinition,
} from './operational-run.schema.js';

export const TeamDutyProfileSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    team: z.string().min(1),
    name: z.string().min(1),
    situationKey: z.enum(TEAM_DUTY_SITUATION_VALUES),
    description: z.string().optional().nullable(),
    isDefault: z.boolean().optional().default(false),
    members: z.array(TeamAssignmentMemberSchema).max(MAX_OPERATIONAL_MEMBERS).default([]),
    executionTasks: z.array(ExecutionTaskCatalogSchema).max(MAX_OPERATIONAL_TASKS).default([]),
    customFields: OperationalCustomFieldsSchema.optional(),
}).superRefine(refineExecutionDefinition);

export const CreateTeamDutyProfileSchema = z.object({
    name: z.string().min(1),
    situationKey: z.enum(TEAM_DUTY_SITUATION_VALUES),
    description: z.string().optional().nullable(),
    isDefault: z.boolean().optional().default(false),
    members: z.array(TeamAssignmentMemberSchema).max(MAX_OPERATIONAL_MEMBERS).optional().default([]),
    executionTasks: z.array(ExecutionTaskCatalogSchema).max(MAX_OPERATIONAL_TASKS).optional().default([]),
    customFields: OperationalCustomFieldsSchema.optional(),
}).superRefine(refineExecutionDefinition);

export const UpdateTeamDutyProfileSchema = z.object({
    name: z.string().min(1).optional(),
    situationKey: z.enum(TEAM_DUTY_SITUATION_VALUES).optional(),
    description: z.string().optional().nullable(),
    isDefault: z.boolean().optional(),
    members: z.array(TeamAssignmentMemberSchema).max(MAX_OPERATIONAL_MEMBERS).optional(),
    executionTasks: z.array(ExecutionTaskCatalogSchema).max(MAX_OPERATIONAL_TASKS).optional(),
    customFields: OperationalCustomFieldsSchema.optional(),
}).superRefine((value, ctx) => {
    if (value.members && value.executionTasks) refineExecutionDefinition(value, ctx);
});
